import { NgModule } from '@angular/core'

// Data display PrimeNG modules
import { PaginatorModule } from 'primeng/paginator'
import { TreeSelectModule } from 'primeng/treeselect'
import { ListboxModule } from 'primeng/listbox'
import { MultiSelectModule } from 'primeng/multiselect'
import { TreeModule } from 'primeng/tree'
import { KnobModule } from 'primeng/knob'
import { ProgressBarModule } from 'primeng/progressbar'
import { ChipModule } from 'primeng/chip'

/**
 * Data display PrimeNG module for tables, charts, and data visualization.
 * Import this only in modules that need data display functionality.
 * Note: ChartModule removed from global scope for better tree-shaking.
 */
@NgModule({
  exports: [PaginatorModule, TreeSelectModule, ListboxModule, MultiSelectModule, TreeModule, KnobModule, ProgressBarModule, ChipModule],
})
export class DataPrimeNGModule {}
